import { render, staticRenderFns } from "./SickOffNote.vue?vue&type=template&id=14addeb8&"
import script from "./SickOffNote.vue?vue&type=script&lang=js&"
export * from "./SickOffNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports